import React from 'react';
import styled from 'styled-components';
import ErrorMessage from '../../components/ErrorMessage';
import PDFViewer from '../../components/PDFViewer';
import fileService from '../../services/fileService';
import { useSteps } from './StepsContext';

const DocumentViewerContainer = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export default function DocumentViewerStep() {
  const [{ currentStep }] = useSteps();
  const assetUrl: string | undefined = currentStep?.task?.assetUrl;

  if (!assetUrl) {
    return <ErrorMessage />;
  }

  return (
    <DocumentViewerContainer>
      <PDFViewer url={fileService.urlOpenFile(assetUrl, undefined)} />
    </DocumentViewerContainer>
  );
}
